import React from 'react'
import { Redirect } from 'react-router-dom'
import PageLayout from '../PageLayout/PageLayout'
import auth from '../../modules/auth'

/**
 * @extends PageLayout
 * @see https://simonsmith.io/reusing-layouts-in-react-router-4/
 */
const PublicLayout = ({component: Component, ...rest}) => (
  <PageLayout {...rest} component={matchProps => 
    !auth.loggedIn() ? (
      <div>
        <Component {...matchProps}/>
      </div>
    ) : (
      <Redirect
        to={{
          pathname: "/reports"
        }}
      />
    )
  } />
)

export default PublicLayout



// WEBPACK FOOTER //
// ./src/layouts/PublicLayout/PublicLayout.js